import type { SpearheadArmyId } from "whole-shared";

import { ClientNighthauntSlasherHost } from "./ClientNighthauntSlasherHost";
import { ClientStormcastEternalsVigilantBrotherhood } from "./ClientStormcastEternalsVigilantBrotherhood";
import { ClientStormcastEternalsYndrastaSpearhead } from "./ClientStormcastEternalsYndrastaSpearhead";
import type { ClientSpearheadArmy } from "./rules";

export const ClientSpearheadArmies: { [key in SpearheadArmyId]: ClientSpearheadArmy } = {
  nh_sh: ClientNighthauntSlasherHost,
  se_vb: ClientStormcastEternalsVigilantBrotherhood,
  se_ys: ClientStormcastEternalsYndrastaSpearhead
};
